<nav class="page-bar">
  <ul class="breadcrumb">
    <li class="links" *ngFor="let link of links; last as isLast;">
      <a tabindex="-1" routerLink="{{link.route}}" routerLinkActive="active" *ngIf="!isLast">{{link.name}}</a>
      <a tabindex="-1" class="disabled" *ngIf="isLast">{{link.name}}</a>
    </li>
    <li class="img-tags" *ngFor="let icon of icons; let indicator=index">
      <itb-icon [tooltipText]="icon.tooltipText" [className]="icon.className"
        (onClickHandler)="iconClickEvent(icon.name,indicator)"></itb-icon>
    </li>
    <li *ngIf="publicLink" class="public-url">
      <span>{{publicLink}}</span>
      <itb-icon [tooltipText]="'Copy'" [className]="'copy'" (onClickHandler)="copyPublicURL(publicLink)"></itb-icon>
    </li>
    <li class="last-update">{{text}}</li>
  </ul>
</nav>